import { environment } from "./../../../environments/environment.hml";
export class PerfilService {
  userData = null;
  userActiveAddress: any = {};

  constructor(
    public $state,
    public PerfilResource,
    public localStorageService,
    public Pedido
  ) {
    "ngInject";
  }

  setActiveAddress(userAddressList) {
    if (!userAddressList) {
      return;
    }

    for (let i = 0; i < userAddressList.length; i++) {
      if (!userAddressList[i].ativo) {
        continue;
      }

      this.userActiveAddress = userAddressList[i];
      this.localStorageService.set("ultimoEndereco", userAddressList[i]);
      this.localStorageService.set(
        "ultimoEnderecoEtiqueta",
        userAddressList[i].etiqueta
      );
    }
  }

  setUserData(user) {
    this.userData = user;

    if (user) {
      const userLocalStorage = this.localStorageService.get("user") || user;
      userLocalStorage.pj = user.pj;
      userLocalStorage.freedom = user.freedom;
      userLocalStorage.integracoes = user.integracoes;
      userLocalStorage.planoContrato = user.planoContrato;

      this.localStorageService.set("user", userLocalStorage);
      this.setActiveAddress(user.enderecos);
    } else {
      this.localStorageService.set("user", null);
    }
  }

  async getClienteData(userId) {
    return this.PerfilResource.getClienteData({ userId }).$promise;
  }

  async getUserData(ignoreCache) {
    if (!ignoreCache && this.userData) {
      return this.userData;
    }

    const data = await this.PerfilResource.getUserData().$promise;
    this.setUserData(data);
    return data;
  }

  async getActiveAddress(goBack) {
    const userData = await this.getUserData(goBack);

    return this.verifyActiveAddress(userData.enderecos);
  }

  async saveUserData(user) {
    // atualiza user no LocalStorage
    const userLocalStorage = this.localStorageService.get("user");
    userLocalStorage.nome = user.nome;
    userLocalStorage.telefone = {
      numero: user.telefone.numero,
      ddd: user.telefone.ddd,
    };

    this.localStorageService.set("user", userLocalStorage);

    return this.PerfilResource.saveUserData(user).$promise;
  }

  getCacheUserData() {
    if (!this.userData) {
      return this.localStorageService.get("user");
    }

    return this.userData;
  }

  isActiveAddress(enderecos) {
    return !!this.verifyActiveAddress(enderecos);
  }

  updateAddress(addressList) {
    this.userData.enderecos = addressList;
  }

  verificarCadastro(user) {
    if (!user.gastoMensalComFrete) {
      return this.$state.go("gasto-mensal", { user });
    }

    if (user.enderecos.length === 0 || !user.telefone) {
      return this.$state.go("endereco", { user });
    }

    if (!user.cpf && !user.cnpj) {
      return this.$state.go("documento", { user });
    }

    if (!user.aceiteTermoContrato && !user.contaLegado) {
      return this.$state.go("termos-de-uso", { user });
    }

    if (!user.aceiteAtualizacaoTermoContrato) {
      return this.$state.go("atualizar-termos-de-uso", { user });
    }

    if (user.planoContrato.soft) {
      return this.$state.go("encomendas");
    }

    if (localStorage.getItem("ls.shippingLabel")) {
      window.location.href = environment.angularJSconstants.URL_SHIPPING_LABEL;
    }

    this.Pedido.redirecionar();
  }

  async getBetaFeatures() {
    return this.PerfilResource.getBetaFeatures().$promise;
  }

  async liberarFormaDePagamento(controller) {
    try {
      const data = await this.getBetaFeatures();
      controller.featureBetaFlag = data.funcionalidades.find(
        (flag) => flag.codigo === "editar-forma-pagamento" && flag.possuiAcesso
      );
    } catch (err) {
      console.error(err);
    }
  }

  async saveHooks(hooks) {
    return this.PerfilResource.saveHooks(hooks).$promise;
  }

  async getToken() {
    return this.PerfilResource.getToken().$promise;
  }

  verifyActiveAddress(addressList) {
    let activeAddress = null;

    for (let i = 0; i < addressList.length; i++) {
      if (addressList[i].ativo) {
        activeAddress = addressList[i];
        break;
      }
    }

    return activeAddress;
  }

  async connectPayPal() {
    return this.PerfilResource.connectPayPal().$promise;
  }
}
